import React__default, { useState } from 'react';
import Collapse from 'reactstrap/lib/Collapse';
import classNames from 'classnames';
import Styles from './Accordion.module.scss.js';
import { ReactComponent as SvgMinus } from '../../icons/Minus.svg.js';
import { ReactComponent as SvgPlus } from '../../icons/Plus.svg.js';

const Item = ({ item, onSelect, isOpen, className, headerClassName, bodyClassName }) => {
    const _onSelect = () => {
        onSelect(item);
    };
    return (React__default.createElement("div", { className: classNames(Styles.itemMain, className) },
        React__default.createElement("h4", { className: classNames(Styles.itemHeader, headerClassName), onClick: _onSelect },
            React__default.createElement("span", { className: Styles.query }, item.header),
            isOpen ? React__default.createElement(SvgMinus, { className: Styles.icon }) : React__default.createElement(SvgPlus, { className: Styles.icon })),
        React__default.createElement(Collapse, { isOpen: isOpen, className: classNames(Styles.itemBody, bodyClassName) }, item.body)));
};
const Accordion = ({ items, className, itemClassName, headerClassName, bodyClassName }) => {
    var _a;
    const [activeItemId, setActiveItemId] = useState((_a = items[0]) === null || _a === void 0 ? void 0 : _a.id);
    const _onSelect = (item) => {
        if (item.id === activeItemId) {
            setActiveItemId(undefined);
        }
        else {
            setActiveItemId(item.id);
        }
    };
    return (React__default.createElement("div", { className: className }, items.map((item, i) => (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Item, { key: item.id, item: item, onSelect: _onSelect, isOpen: item.id === activeItemId, className: classNames(i !== items.length - 1 && Styles.bottomBorder, itemClassName), headerClassName: headerClassName, bodyClassName: bodyClassName }))))));
};
// export interface AccordionHeaderProps {
//     itemKey: number | string;
// }
// export const AccordionHeader: FC<AccordionHeaderProps> = ({ itemKey, children }) => {
//     const _onSelect = () => {
//         onSelect(itemKey);
//     };
//     return <div onClick={_onSelect}>{children}</div>;
// };

export { Accordion as default };
//# sourceMappingURL=Accordion.js.map
